import { Button } from "primereact/button";
import { JVInput } from "../../../shared/JVInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useState } from "react";
import { IMassMailRequestServingSetting } from "./MassMailRequestServingSettingTable";

interface IProps {
    reload: boolean,
    setReload: (reload: boolean) => void,
    toast: any,
}

const schema = yup.object({
    request_Serving_Limit: yup.number().min(0).typeError("Request Serving Limit should be number").required("No of Request Serving Limit is required"),
    request_Serving_Wait_Time: yup.number().min(0).typeError("Minutes should be number").required("No of Minutes required"),
});

export const MassMailRequestServingSettingForm = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, } = useForm<IMassMailRequestServingSetting>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    const saveToDB = async (body: IMassMailRequestServingSetting) => {
        const method = "PUT";
        const message = "Updated Successfully";
        setLoading(true);
        delete body.updated_By;

        const resp = await Fetch("MassMail/updateMailsServingRequestSetting", method, body, null, null);
        if (resp) {
            props.toast.current.show({ severity: "success", detail: message, life: 3000, });
            props.setReload(!props.reload);
            setLoading(false);
        } else setLoading(false);
    };

    const onsubmit = (data: IMassMailRequestServingSetting) => {
        saveToDB(data);
    };

    const loadTableData = async () => {
        const response = await Fetch("MassMail/getMailsServingRequestSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailRequestServingSetting> = await response.json();
            reset(data[0]);
        }
    };

    useEffect(() => {
        loadTableData();
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit(onsubmit)}>
                <div className="p-fluid formgrid grid">
                    <JVInput required column={4} label="Next Mass Mail Request Serving Limit" control={control} name="request_Serving_Limit" error={errors.request_Serving_Limit?.message} />
                    <JVInput required column={4} label="Next Mass Mail Request Serving Wait Time (in minutes)" control={control} name="request_Serving_Wait_Time" error={errors.request_Serving_Wait_Time?.message} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="submit" ></Button>
                </div>
            </form>
        </>
    );
};